import { motion } from "framer-motion";

interface HandDrawnUnderlineProps {
	className?: string;
}

function HandDrawnUnderline({ className = "" }: HandDrawnUnderlineProps) {
	const pathVariants = {
		hidden: {
			pathLength: 0,
			opacity: 0,
		},
		visible: {
			pathLength: 1,
			opacity: 0.8,
			transition: {
				pathLength: {
					duration: 2,
					ease: "easeInOut",
					delay: 0.5,
				},
				opacity: {
					duration: 0.3,
					delay: 0.5,
				},
			},
		},
	};

	return (
		<div className={`-bottom-6·absolute·inset-x-0·h-6·overflow-visible·${className}`}>
			<svg
				aria-hidden="true"
				viewBox="0 0 400 20"
				className="h-full w-full"
				preserveAspectRatio="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<motion.path
					d="M5 12c8-2 15 1 25-1s18 2 28-1 20-3 30 1 22 2 32-1 24-2 35 0 26 3 37-1 28-1 40 1 30-2 42 2 32 1 45-1 35-3 48 0"
					stroke="currentColor"
					strokeWidth="2.5"
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
					className="text-yellow-500"
					variants={pathVariants}
					initial="hidden"
					animate="visible"
				/>
			</svg>
		</div>
	);
}

export default HandDrawnUnderline;
